import dayjs from 'dayjs';
import { useLocation } from 'react-router-dom';
import styles from 'styles/components/upgradeBanner.module.scss';
import UpgradeButton from 'components/upgradeButton';
import ProfileContext from 'services/profileContext';
import { useContext } from 'react';
import pluralize from 'pluralize';

const UpgradeBanner = () => {
  const location = useLocation();
  const isMyPage = location.pathname.startsWith('/my');
  const { profile } = useContext(ProfileContext);
  const daysRemaining = dayjs(profile.workspace?.freeTrialEndDate).diff(
    dayjs(),
    'day'
  );

  if (isMyPage) {
    return null;
  }

  return (
    <div className={styles.wrapper}>
      <div className={styles.inner}>
        {daysRemaining < 0 ? (
          <span style={{ color: 'white' }}>
            Free trial expired.&nbsp;Upgrade now to continue using the app.
          </span>
        ) : (
          <>
            <b>{daysRemaining} {pluralize('day', daysRemaining)} remaining</b>
            &nbsp; on the free trial. Upgrade now to continue using the app.
          </>
        )}
        <UpgradeButton style={{ marginLeft: 10 }} />
      </div>
    </div>
  );
};

export default UpgradeBanner;
